import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const ProductionChainCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "production-chain-cell",
})`
  display: inline-flex;
  align-items: center;
  min-width: 0;

  .production-chain-cell__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
